import IWall from 'components/interfaces/IWall';

import { ALU_2K_GLAZY, SLIDY_30, SLIDY_36 } from './glazingWallTypes';
import { is2kAluGlazy, isSlidy30, isSlidy36 } from './glazingWallTypesCheck';

export const SE0010 = 'SE0010';
export const SE0020 = 'SE0020';
export const SE0026 = 'SE0026';
export const SE0134 = 'SE0134';
export const SE0135 = 'SE0135';
export const SE0180 = 'SE0180';
export const SE0204 = 'SE0204';
export const SE0229 = 'SE0229';
export const SEXXXX20 = 'SEXXXX20';

const verticalProfileTypes = [
  SE0010,
  SE0020,
  SE0026,
  SE0134,
  SE0135,
  SE0180,
  SE0229,
  SEXXXX20,
];

export const getFirstDoorVerticalProfileTypes = (
  wallType: string
): string[] => {
  if (wallType === ALU_2K_GLAZY) {
    return [SE0204];
  }

  if (wallType === SLIDY_30) {
    return [SE0010, SE0020];
  }

  if (wallType === SLIDY_36) {
    return [SE0180, SEXXXX20];
  }

  return ['-', ...verticalProfileTypes];
};

export const slidyMiddleDoorVerticalProfileTypes = ['-', SE0134, SE0135];

export const getMiddleDoorVerticalProfileTypes = (wall: IWall): string[] => {
  if (isSlidy30(wall) || isSlidy36(wall)) {
    if (wall.aluGlazyFloorProfileType === SE0026) {
      return ['-', SE0026];
    }

    return slidyMiddleDoorVerticalProfileTypes;
  }

  if (is2kAluGlazy(wall)) {
    return [SE0204];
  }

  return ['-', ...verticalProfileTypes];
};

export default verticalProfileTypes;
